import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Secondary, Text } from "@cinch-labs/design-system";
import { useViewport } from "@cinch-labs/shared-util";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import Image from "next/legacy/image";
import styles from "./help-me-choose.module.css";
const HelpMeChoose = ({ title , heading , body , ctaText , image  })=>{
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    const { trackEvent  } = useAnalytics();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Help me choose`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "button",
                    label: "Help me choose quiz banner",
                    action: "Help me choose"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                element: "h2",
                className: styles["title"],
                children: title
            }),
            /*#__PURE__*/ _jsxs("section", {
                className: styles["container"],
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles["leftSection"],
                        children: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    element: "h3",
                                    className: styles["heading"],
                                    children: heading
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    element: "p",
                                    className: styles["body"],
                                    children: body
                                }),
                                /*#__PURE__*/ _jsx(Secondary, {
                                    "data-testid": "help-me-choose-button",
                                    classNames: {
                                        button: styles["buttonContainer"]
                                    },
                                    type: "submit",
                                    variant: "alternative",
                                    element: "a",
                                    href: "/help-me-choose/most-important",
                                    onClick: handleClick,
                                    children: ctaText
                                })
                            ]
                        })
                    }),
                    isMobile ? null : /*#__PURE__*/ _jsx("div", {
                        className: styles["image"],
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: image.filename,
                            alt: image.alt ?? "",
                            layout: "responsive",
                            width: 408,
                            height: 265
                        })
                    })
                ]
            })
        ]
    });
};
export default HelpMeChoose;
